import {
    GET_ALL_EXPLORE_DESIGNS,
    SET_ALL_EXPLORE_DESIGNS,
    SET_EXPLORE_DESIGNS_LOADING
} from '../../@types/thunk.types'
import axios from 'axios'
import { fetchExploreDesigns } from '../../../services/v3/DesignLab/DesignLab'
import { ExploreDesignAction } from './ExploreDesignSlice'

export const ExploreDesignThunks = {
    [GET_ALL_EXPLORE_DESIGNS]:
        (params, isExploreMore = false, requetBody, cancelToken) =>
        async (dispatch) => {
            try {
                dispatch(ExploreDesignAction[SET_EXPLORE_DESIGNS_LOADING](true))
                const data = await fetchExploreDesigns(
                    params,
                    requetBody,
                    cancelToken
                )
                dispatch(
                    ExploreDesignAction[SET_ALL_EXPLORE_DESIGNS]({
                        data,
                        merge: data.currentPage > 0 || isExploreMore === true
                    })
                )
                dispatch(
                    ExploreDesignAction[SET_EXPLORE_DESIGNS_LOADING](false)
                )
            } catch (e) {
                // Request was canceled because a newer one is already in
                // flight; keep the loader on for that new request.
                if (axios.isCancel(e)) {
                    return
                }
                dispatch(
                    ExploreDesignAction[SET_EXPLORE_DESIGNS_LOADING](false)
                )
            }
        }
}
